import React, { useState, useCallback } from 'react';
import Cards from 'react-credit-cards';
import type { Focused } from 'react-credit-cards';

import 'react-credit-cards/es/styles-compiled.css';

import { useFormikContext, Field } from 'formik';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { ICard } from './index';

const NewCard = () => {
  const [currentField, setCurrentField] = useState<Focused>('number');

  const { values, handleBlur } = useFormikContext<ICard>();

  const onFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const field = e.target.name as Focused;
    setCurrentField(field);
  }, []);

  const onBlurCvc = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      setCurrentField('name');
      handleBlur(e);
    },
    [handleBlur]
  );

  return (
    <div className='grid items-center gap-8 md:grid-cols-2'>
      <div className='flex justify-center'>
        <Cards
          focused={currentField}
          cvc={values.cvc}
          expiry={values.expiry}
          name={values.name}
          number={values.number}
          locale={{ valid: 'Validade' }}
          placeholders={{ name: 'SEU NOME AQUI' }}
        />
      </div>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
        <div className='md:col-span-2'>
          <Field
            id='card-number-input'
            name='number'
            component={TextFormField}
            fullWidth
            label='Número do cartão'
            placeholder='Insira o número do cartão'
            mask='creditcard'
            onFocus={onFocus}
          />
        </div>
        <div className='md:col-span-2'>
          <Field
            id='card-name-input'
            name='name'
            component={TextFormField}
            fullWidth
            label='Nome impresso no cartão'
            placeholder='Insira o nome igual do cartão'
            onFocus={onFocus}
            mask={'onlylettersandspace'}
            maxLength={50}
          />
        </div>
        <div>
          <Field
            id='card-expiration-date-input'
            name='expiry'
            component={TextFormField}
            fullWidth
            label='Data de expiração'
            placeholder='MM/AA'
            onFocus={onFocus}
            inputMode='numeric'
            mask={'expirydate'}
          />
        </div>
        <div>
          <Field
            id='card-cvv-input'
            name='cvc'
            component={TextFormField}
            fullWidth
            label='Código de segurança'
            placeholder='Insira o CVV do cartão'
            onFocus={onFocus}
            onBlur={onBlurCvc}
            maxLength={4}
          />
        </div>
      </div>
    </div>
  );
};
export default NewCard;
